import { map } from 'lodash/fp';
import loadEstimate from '../loadEstimate';
import setItemAttribute from '../../api/designBuilder/setItemAttribute';
import deleteProduct from '../../api/designBuilder/deleteProduct';
import getChangedAttributes from './getChangedAttributes';

const editMandiAttributes = (oldAttributes, newValues, reason, designId, itemId) => (
  async (dispatch) => {
    const attributes = getChangedAttributes(newValues, oldAttributes);

    await Promise.all(map(
      ({ attributeId, newValue }) =>
        setItemAttribute(designId, itemId, attributeId, newValue, reason),
      attributes,
    ));

    await deleteProduct(designId, itemId);

    return dispatch(loadEstimate(designId));
  });

export default editMandiAttributes;
